import React from 'react';
import { useDispatch } from 'react-redux';

import { addContent } from '../../modules/editor';
import useDebounce from '../../hooks/useDebounce';

type Props = {
	canDrop: boolean
	seq: number
};

function ContentListDropzone({ canDrop, seq }: Props) {
	const dispatch = useDispatch();

	const [dbActiveTop, activeTop, setActiveTop] = useDebounce<boolean>(
		false,
		30
	);
	const [dbActiveBottom, activeBottom, setActiveBottom] = useDebounce<boolean>(
		false,
		30
	);

	const onDrop = (e: any, position:string) => {
		e.preventDefault();
		const data = e.dataTransfer.getData("text/plain");
		if (data.length === 0) {
			return;
		}
		dispatch(addContent({ seq: position === 'bottom' ? seq + 1 : seq, componentId: data}));
		setActiveTop(false);
		setActiveBottom(false);
	}

	const onDragOver = (e: any) => {		
		e.preventDefault();
		e.dataTransfer.dropEffect = "move";
	}

	return (
		<>
		{
			canDrop && (
				<div className='add-content-drop' >
					{
						seq === 0 && (
							<div
								className={dbActiveTop ? 'dropzone top active' : 'dropzone top'}
								onDrop={(e) => {onDrop(e, 'top')}}
								onDragOver={(e:any) => {onDragOver(e); setActiveTop(true)}}
								onDragLeave={(e:any) => {setActiveTop(false)}}
								onDragEnd={(e:any) => {setActiveTop(false)}}
							>
								<div className="drop-line">					
									여기에 상자를 추가합니다.			
								</div>
							</div>
						)
					}
					<div
						className={dbActiveBottom ? 'dropzone bottom active' : 'dropzone bottom'}
						onDrop={(e) => {onDrop(e, 'bottom')}}
						onDragOver={(e:any) => {onDragOver(e); setActiveBottom(true)}}
						onDragLeave={(e:any) => {setActiveBottom(false)}}
						onDragEnd={(e:any) => {setActiveBottom(false)}}
					>
						<div className="drop-line">		
							여기에 상자를 추가합니다.			
						</div>
					</div>
				</div>
			)
		}
		</>
	);
}

export default ContentListDropzone;